import {useQuery} from "@tanstack/react-query";
import { useEmbeddyCrockerApiClient } from "../../hooks/useApiClient";
import MultiSelectDropdown from "../dropdowns/multiSelectDropdown";
import {useState} from "react";
import {MultiSelectDropdownSmartWrapperProps} from "../dropdowns/types";


export const AIImageSearchSourcesDropdown = ({...dropdownProps}: MultiSelectDropdownSmartWrapperProps<string, string>) => {
    const api = useEmbeddyCrockerApiClient();
    const [searchTerm, setSearchTerm] = useState("");
    const { data: rawSources, isLoading: sourcesAreLoading } = useQuery({
    queryKey: ["ai-search-sources"],
    queryFn: async () => api.imageEmbedding.getListOfSources({}).then((r) => r.items),
    throwOnError: true,
    refetchOnWindowFocus: false,
  });

    const sources = rawSources?.filter(s => s.toLowerCase().includes(searchTerm)) || []

    return (
        <MultiSelectDropdown<string, string>
            label={"Sources"}
            options={sources}
            selections={[]}
            isLoading={sourcesAreLoading}
            renderOption={o => o}
            onSearchTermChange={setSearchTerm}
            mapOptionToSelection={s => s}
            {...dropdownProps}
        />
    )
}